// Rótulos e helpers compartilhados pelas telas de gestão de acesso (TRI-103 a TRI-105).

// Roles que acessam a área; a API exige as mesmas (GestaoAcessoOptions.RolesDaArea)
export const ROLES_DA_AREA = ['admin', 'gestao_acesso']

// Enum AcaoGestaoAcesso da API (os valores vêm como número)
export const ACOES = {
  1: 'Criação',
  2: 'Alteração',
  3: 'Exclusão',
  4: 'Role atribuída',
  5: 'Role removida',
  6: 'Entrada no grupo',
  7: 'Saída do grupo',
  8: 'Habilitação',
  9: 'Desabilitação',
  10: 'Sessões encerradas',
  11: 'Ações obrigatórias enviadas',
  12: 'Grupo movido',
  13: 'Role composta incluída',
  14: 'Role composta removida'
}

// Enum TipoAlvoGestaoAcesso da API
export const TIPOS_ALVO = { 1: 'Usuário', 2: 'Grupo', 3: 'Role' }

export const ACOES_OBRIGATORIAS = [
  { id: 'UPDATE_PASSWORD', nome: 'Redefinir senha' },
  { id: 'VERIFY_EMAIL', nome: 'Verificar e-mail' }
]

// Árvore de grupos da API em lista plana { id, caminho, protegido }, na ordem da árvore
export const achatarGrupos = (arvore, lista = []) => {
  for (const grupo of arvore ?? []) {
    lista.push({ id: grupo.id, caminho: grupo.caminho ?? grupo.nome, protegido: grupo.protegido })
    achatarGrupos(grupo.subgrupos, lista)
  }
  return lista
}

// Mesma regra do guard da API: item terminado em * vale como prefixo
export const roleProtegida = (nome, protegidas = []) =>
  protegidas.some((p) => (p.endsWith('*') ? nome?.toLowerCase().startsWith(p.slice(0, -1).toLowerCase()) : p.toLowerCase() === nome?.toLowerCase()))

export const nomeCompleto = (usuario) => [usuario?.nome, usuario?.sobrenome].filter(Boolean).join(' ') || '—'
